import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { timeout } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SettingService {
  constructor(private http: HttpClient) {}

  getCurrentPolicy(): Observable<any> {
    const url = `${environment.url.api}/policy/intensiveMonitoring`;
    return this.http.get<any>(url).pipe(timeout(environment.config.apiWaitingTime));
  }

  create(params: any): Observable<any> {
    const url = `${environment.url.api}/policy/intensiveMonitoring`;
    return this.http.post<any>(url, params).pipe(timeout(environment.config.apiWaitingTime));
  }
}
